import { useScrollReveal } from '@/hooks/useScrollReveal'

interface ScrollRevealProps {
  children: React.ReactNode
  className?: string
  threshold?: number
  rootMargin?: string
  direction?: 'up' | 'down' | 'left' | 'right' | 'none'
  delay?: number
  duration?: number
  as?: keyof JSX.IntrinsicElements
}

export default function ScrollReveal({
  children,
  className = '',
  threshold = 0.1,
  rootMargin = '0px 0px -40px 0px',
  direction = 'up',
  delay = 0,
  duration = 700,
  as: Tag = 'div',
}: ScrollRevealProps) {
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>({ threshold, rootMargin })

  const directionClasses = {
    up: 'translate-y-10',
    down: '-translate-y-10',
    left: 'translate-x-10',
    right: '-translate-x-10',
    none: '',
  }

  return (
    <Tag
      ref={ref}
      className={`${className} transition-all ${directionClasses[direction]} ${
        isVisible
          ? 'translate-y-0 translate-x-0 opacity-100'
          : 'opacity-0'
      }`}
      style={{
        transitionDuration: `${duration}ms`,
        transitionDelay: `${delay}ms`,
        transitionTimingFunction: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
      }}
    >
      {children}
    </Tag>
  )
}